import React from 'react';

type Props = {
    className?: string;
    fillColor?: string;
    width?: number;
    height?: number;
};

const BlueprintsIcon = React.memo(function BlueprintsIcon({
    className,
    fillColor = 'currentColor',
    width = 23,
    height = 23,
}: Props) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M3.6 22C3.16 22 2.78333 21.8433 2.47 21.53C2.15667 21.2167 2 20.84 2 20.4V12.4C2 11.96 2.15667 11.5833 2.47 11.27C2.78333 10.9567 3.16 10.8 3.6 10.8H16.4C16.84 10.8 17.2167 10.9567 17.53 11.27C17.8433 11.5833 18 11.96 18 12.4V20.4C18 20.84 17.8433 21.2167 17.53 21.53C17.2167 21.8433 16.84 22 16.4 22H3.6ZM3.6 20.4H16.4V12.4H3.6V20.4ZM8.4 19.6L13.2 16.4L8.4 13.2V19.6ZM3.6 10V8.4H16.4V10H3.6ZM6 7.6V6H14V7.6H6Z"
                    fill={fillColor}
                />
                <path
                    d="M18.181 4.47822L16.7399 6.22474L16.3651 3.99164L14.6186 2.5505L16.8517 2.1757L18.2928 0.429182L18.6676 2.66228L20.4141 4.10342L18.181 4.47822Z"
                    fill={fillColor}
                />
                <path
                    d="M19.5175 6.93185L21.0039 6.6779L21.967 5.51764L22.221 7.00401L23.3812 7.96713L21.8948 8.22108L20.9317 9.38134L20.6778 7.89497L19.5175 6.93185Z"
                    fill={fillColor}
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
});

export default BlueprintsIcon;
